import { storeTokens } from "../../requestors/loginRequestor";

export const relayTokens = async (
  accessToken: string,
  refreshToken: string
): Promise<void> => {
  try {
    const response = await storeTokens(accessToken, refreshToken);
    console.log("✅ Tokens stored successfully:", response);
  } catch (err) {
    console.error("❌ Failed to store tokens:", err);
  }
};
